export default __webpack_public_path__ + "static/media/pegn.66610b19.jpg";